import {Mapper} from '@s-ui/domain'

import {SessionAuthenticationValueObject} from '../ValueObjects/SessionAuthenticationValueObject.js'

export default class HttpResponseToSessionAuthenticationMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Func<UserDataCommon>} deps.userDataCommonFactory
   * @param {Func<LogUserCommon>} deps.logUserCommonFactory
   */
  constructor({userDataCommonFactory, logUserCommonFactory, loginCookieExpirationDate}) {
    super({
      userDataCommonFactory,
      logUserCommonFactory
    })

    this._userDataCommonFactory = userDataCommonFactory
    this._logUserCommonFactory = logUserCommonFactory
    this._loginCookieExpirationDate = loginCookieExpirationDate
  }

  _setExpirationDate() {
    const now = new Date()
    now.setDate(now.getDate() + this._loginCookieExpirationDate)
    return now.getTime()
  }

  /**
   * @method
   * @param {Object} params
   * @param {Object} params.user
   * @param {Object} params.auth
   * @param {Object} params.consents
   * @return {SessionValueObject}
   */
  map = userCredentialsResponse => {
    const {auth, user, consents} = userCredentialsResponse

    const {contractId, lastName, zipCode, verified, phone, name, avatarUrl, id, provinceId, email, hidePhone} = user
    const {uid, token, userId} = auth

    return SessionAuthenticationValueObject.create({
      userData: this._userDataCommonFactory({
        contractId,
        avatar: avatarUrl,
        email,
        emailConfirmed: verified,
        expires: this._setExpirationDate(),
        hidePhone,
        lastName,
        name,
        phone,
        provinceID: provinceId,
        token,
        UID: uid,
        userID: id,
        zipCode
      }),
      logUser: this._logUserCommonFactory({
        token,
        UID: uid,
        userID: userId
      }),
      consents
    })
  }
}
